module.exports = __webpack_public_path__ + "assets/b70.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b70.png
// module id = 661
// module chunks = 0